import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { UserConsumer } from "../../UserContext";
import moment from "moment";

export const RejectTimesheetModal = ({
	showModal,
	handleClose,
	commentHeading,
	rejectionDate,
	handleOnSubmit,
}) => {
	const [reason, setReason] = useState("");
	const handleChangeReason = (e) => {
		setReason(e.target.value);
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				return (
					<div>
						<Modal
							show={showModal}
							onHide={handleClose}
							aria-labelledby="contained-modal-title-vcenter"
							centered
							dialogClassName="modal-50w"
							className="addComments"
						>
							<Modal.Header
								closeButton
								className="pb-0 pr-4 pt-1 border-0"
							/>
							<Modal.Body closeButton>
								<div className="pr-3">
									<div className="row text-center">
										<div className="col-lg-8 col-md-8 col-sm-12 font-weight-light mb-2 text-left">
											Submitted timesheet Date:
											<div className="d-inline font-weight-bold han ml-2 projectName px-2 py-1">
												{moment(rejectionDate).format(
													"ddd DD MMM"
												)}
											</div>
										</div>
									</div>
								</div>

								<div className="mb-2 mt-3 font-weight-light">
									{commentHeading}
								</div>
								<div className="row">
									<div className="col-lg-12 col-md-12 col-sm-12 h-auto">
										<textarea
											id="reason"
											className="comment"
											value={reason}
											onChange={handleChangeReason}
											maxLength="200"
										></textarea>
									</div>
								</div>
								<div className="row saveDiv">
									<Button
										className="save"
										disabled={reason === ""}
										onClick={() => {
											handleOnSubmit(
												reason,
												rejectionDate
											);
										}}
									>
										Submit
									</Button>
								</div>
							</Modal.Body>
						</Modal>
					</div>
				);
			}}
		</UserConsumer>
	);
};
export default RejectTimesheetModal;
